'use client';

import { ErrorNotice } from '~/components';

export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html>
      <body>
        <ErrorNotice
          onResetClick={() => {
            // Attempt to recover by trying to re-render the segment
            reset();
          }}
        />
      </body>
    </html>
  );
}
